// extracted by mini-css-extract-plugin
export default {"rating":"uC-z","numberOfStars":"vC-z","count":"wC-z","barGraphSpacing":"xC-z","barGraph":"yC-z"};